import { useSendOnCopilotChannel } from 'copilot-toolkit/channel/hooks/useSendOnCopilotChannel';
import { TOPIC_NAMES } from 'copilot-toolkit/types/Channel';
export const useCollaborateCopilotActions = () => {
  const invokeActionOfSession = useSendOnCopilotChannel(TOPIC_NAMES.COLLABORATE_COPILOT_ACTON);
  const requestContextFromSession = useSendOnCopilotChannel(TOPIC_NAMES.COLLABORATE_COPILOT_GET_CONTEXT);
  const handleCopilotAction = (payload, sessionId, usageTracker) => {
    if (payload) {
      invokeActionOfSession({
        payload: Object.assign({}, payload, {
          sessionId: sessionId || ''
        }),
        usageTracker
      });
    }
  };
  return {
    handleCopilotAction,
    requestContextFromSession
  };
};